import { render, staticRenderFns } from "./Page10.vue?vue&type=template&id=2fa2f18b&scoped=true&"
import script from "./Page10.vue?vue&type=script&lang=js&"
export * from "./Page10.vue?vue&type=script&lang=js&"
import style0 from "./Page10.vue?vue&type=style&index=0&id=2fa2f18b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa2f18b",
  null
  
)

export default component.exports